@if (trainingDetails()?.additional_description && this.arrayToDisplay().length) {
  <div class="www-pro-exp-con-txt" [appAnimate]="'landing'" [speed]="'fast'" [aos]="0.1">
    <span class="www-pro-exp-con-txt__col-txt d-none d-md-block">
      {{ arrayToDisplay()[0] }}
    </span>
    <span class="www-pro-exp-con-txt__col-txt d-none d-md-block">
      {{ arrayToDisplay()[1] }}
    </span>

    <span class="www-pro-exp-con-txt__col-txt d-block d-md-none">
      {{ trainingDetails()?.additional_description }}
    </span>
  </div>
}
